var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('router-link',{staticClass:"link",attrs:{"to":"/detail/about"}},[_vm._v("ABOUT US")]),_c('router-link',{staticClass:"link",attrs:{"to":"/detail/contact"}},[_vm._v("CONTACT US")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }